import PropTypes from 'prop-types';
import { 
  Car, 
  Droplets, 
  Lock, 
  Package, 
  Coffee, 
  Wifi,
  Check,
  X
} from 'lucide-react';
import { Text } from '@/components/ui/index.js';
import styles from './AmenityList.module.css';

/**
 * AmenityList - Grid of venue amenities with availability indicators
 */
export function AmenityList({ amenities }) {
  return (
    <div className={styles.grid}>
      {amenities.map((amenity) => (
        <AmenityItem 
          key={amenity.name}
          name={amenity.name}
          available={amenity.available}
        />
      ))}
    </div>
  );
}

/**
 * Individual amenity item
 */
function AmenityItem({ name, available }) {
  const Icon = getAmenityIcon(name);
  
  return (
    <div className={`${styles.item} ${available ? styles.available : styles.unavailable}`}>
      <div className={styles.iconWrapper}>
        <Icon size={20} />
        <div className={styles.statusBadge}>
          {available ? (
            <Check size={10} className={styles.checkIcon} />
          ) : (
            <X size={10} className={styles.xIcon} />
          )}
        </div>
      </div>
      <Text size="sm" color={available ? 'primary' : 'muted'} className={styles.name}>
        {name}
      </Text>
    </div>
  );
}

/**
 * Get the appropriate icon for an amenity
 */
function getAmenityIcon(name) {
  const iconMap = {
    'Parking': Car,
    'Showers': Droplets,
    'Lockers': Lock,
    'Equipment Rental': Package,
    'Cafe': Coffee,
    'WiFi': Wifi,
  };
  
  return iconMap[name] || Package;
}

AmenityList.propTypes = {
  amenities: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      available: PropTypes.bool.isRequired,
    })
  ).isRequired,
};

AmenityItem.propTypes = {
  name: PropTypes.string.isRequired,
  available: PropTypes.bool.isRequired,
};

export default AmenityList;
